export class SiteGridViewItem {
    id?: string;
    name?: string;
    isPaco?: boolean;
    constructor(siteGridViewItem?: SiteGridViewItem) {
        this.id = siteGridViewItem?.id;
        this.name = siteGridViewItem?.name;       
        this.isPaco = siteGridViewItem?.isPaco;       
    }
}
